export const BUSINESS_CASE_SIGNAL_SEVERITIES = ['info', 'warning', 'danger'] as const;
